import axios from 'axios';

const isTokenExpire = () => {
    const itemStr = localStorage.getItem('token');
    if (!itemStr) return true;

    const item = JSON.parse(itemStr);
    const now = new Date();

    if (now.getTime() > item.expiry) {
        localStorage.removeItem('token');
        window.location.href = "/login";
        return true;
    }
    return false;
}
const updateExpiryToken = () => {
    const itemStr = localStorage.getItem('token');
    const item = JSON.parse(itemStr);
    const now = new Date();
    const fourHoursInMs = 4 * 60 * 60 * 1000;//4 hour
    const updatedItem = {
        token: item.token,
        expiry: now.getTime() + fourHoursInMs, // ttl in milliseconds
    };
    localStorage.removeItem('token');
    localStorage.setItem('token',JSON.stringify(updatedItem));
}


const Network = {
  // instance: () => {
  //     return axios.create({
  //       baseURL: Urls.BASE_URL_PREFIX,
  //       headers: { 'Content-Type': 'application/json' },
  //       headers : {'Access-Control-Allow-Origin' : '*'},
       
  //     });
  // },
  
  get: (url) => {
    return axios.create({
      baseURL: url,
      headers: { 'Content-Type': 'application/json' },
    }).get(url, { "crossdomain" : true})
           .then(function (response) { return response })
           .catch(function (error) { return error })
  },
  post: (url, parameters,isSubmitFiles = false) => {
     if (parameters === null) {
       return axios.create({
         baseURL: url,
         // headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin' : '*'},
         headers: { 'Content-Type': 'application/json'},
        }).post(url)
        .then(function (response) { return response })
        .catch(function (error) { return error })
      }
      if(!isTokenExpire()){
        updateExpiryToken();     
        if(isSubmitFiles === true){
        return axios.create({
            baseURL: url,
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin' : '*'},
        }).post(url,parameters)
                  .then(function (response) { return response })
                  .catch(function (error) { return error })
        }else{
        return axios.create({
            baseURL: url,
            // headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin' : '*'},
            headers: { 'Content-Type': 'multipart/form-data','Accept':'application/json'},
        }).post(url,parameters)
                  .then(function (response) { return response })
                  .catch(function (error) { return error })
        }
      }
  }
   
};

export default Network;